import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { ReconcileScreen } from "../screens/ReconcileScreen";

export const Route = createFileRoute("/prototype/c/$companyId/banking/$accountId/reconcile")({
  component: Reconcile,
});

function Reconcile() {
  const { companyId, accountId } = Route.useParams();
  return (
    <ReconcileScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      accountId={accountId}
    />
  );
}
